var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 8.375L7.75 5.5L10.625 2.65625C11.0938 2.15625 11.0938 1.375 10.625 0.875C10.125 0.40625 9.34375 0.40625 8.84375 0.875L6 3.75L3.125 0.875C2.625 0.40625 1.84375 0.40625 1.34375 0.875C0.875 1.375 0.875 2.15625 1.34375 2.65625L4.21875 5.5L1.34375 8.375C0.875 8.875 0.875 9.65625 1.34375 10.1562C1.84375 10.625 2.625 10.625 3.125 10.1562L6 7.28125L8.84375 10.1562C9.34375 10.625 10.125 10.625 10.625 10.1562C11.0938 9.65625 11.0938 8.875 10.625 8.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3222f588545caf0af54572367ba77f5b.svg";
export { ForwardRef as ReactComponent };